import axios from "axios";
import Cookies from "universal-cookie";

const { REACT_APP_BOT_BASE_URL, REACT_APP_BOT_CLIENT_ID } = process.env;
const cookies = new Cookies();

const createAxiosInstance = (baseURL) => {
  return axios.create({
    baseURL: baseURL,
    headers: {
      client_id: REACT_APP_BOT_CLIENT_ID,
      access_token: cookies.get("access_token"),
      user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
};

const whatsappQueryApi = createAxiosInstance(REACT_APP_BOT_BASE_URL);

const applyAccessTokenInterceptor = (apiInstance) => {
  apiInstance.interceptors.request.use(
    (req) => {
      const token = cookies.get("access_token");
      if (token) {
        req.headers["access_token"] = token; // Set Access Token
      }
      return req;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  apiInstance.interceptors.response.use(
    (req) => {
      return req;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
};

applyAccessTokenInterceptor(whatsappQueryApi);

export const getUsers = () =>
  new Promise((resolve, reject) => {
    whatsappQueryApi
      .get(`/v1/whatsapp/users/get`)
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.log(error);
        reject(error.response);
      });
  });

export const getUserMessages = (requestData) =>
  new Promise((resolve, reject) => {
    whatsappQueryApi
      .post(`/v1/whatsapp/user/messages/get`, { ...requestData })
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.log(error);
        reject(error.response);
      });
  });

export const changeUserQueryStatus = (requestData) =>
  new Promise((resolve, reject) => {
    whatsappQueryApi
      .post(`/v1/whatsapp/user/status/change`, { ...requestData })
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.log(error);
        reject(error.response);
      });
  });

export const sendMessageToUser = (requestData) =>
  new Promise((resolve, reject) => {
    whatsappQueryApi
      .post(`/v1/whatsapp/message/send`, { ...requestData })
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.log(error);
        reject(error.response);
      });
  });

export const sendMediaMessageToUser = (requestData) =>
  new Promise((resolve, reject) => {
    whatsappQueryApi
      .post(`/v1/whatsapp/message/send/file`, requestData)
      .then((response) => {
        resolve({ status: "success", data: response.data?.data });
      })
      .catch((error) => {
        console.log(error);
        reject(error.response);
      });
  });

export { whatsappQueryApi };
